import { first } from 'rxjs/operators'

import { Item, Record } from '@skinsoft/types'
import { itemSelectors, recordSelectors } from '@skinsoft/selectors'
import { CACHE_KEYS, OfflineDataFetcher } from '@skinsoft/offline'
import { ItemOfflineDataFetcher } from './item-offline-data-fetcher'
import { matchesRegex } from '@skinsoft/utils'

export class RecordOfflineDataFetcher extends OfflineDataFetcher<Record>{
    private itemOfflineDataFetcher: ItemOfflineDataFetcher
    
    constructor(cacheKey: string) {
        super(cacheKey)
        this.itemOfflineDataFetcher = new ItemOfflineDataFetcher(CACHE_KEYS.Item)
    }

    protected async queryTextFilter(entity: Record, queryText: string, locale: string): Promise<boolean> {
        const lowerCaseQueryText: string = queryText.toLowerCase()
        // record title
        const title: string = recordSelectors.recordIdentifier(entity);
        const titleMatch = title ? matchesRegex(queryText, title) : false;

        // record linked object identifier
        const linkedItemId: string = recordSelectors.linkedItemId(entity);
        const item: Item | null = linkedItemId ? await this.itemOfflineDataFetcher.fetchOneFromId(linkedItemId).pipe(first()).toPromise() : null
        const itemIdentifier = item ? itemSelectors.identifier(item, locale) : ""
        const itemIdentifierMatch = itemIdentifier ? matchesRegex(lowerCaseQueryText, itemIdentifier.toLowerCase()) : false;

        return titleMatch || itemIdentifierMatch;
    }
}